
import React from 'react';

interface ChartGridProps {
  innerRectX: number;
  innerRectY: number;
  innerRectWidth: number;
  innerRectHeight: number;
}

export const ChartGrid: React.FC<ChartGridProps> = ({ 
  innerRectX, 
  innerRectY, 
  innerRectWidth, 
  innerRectHeight 
}) => {
  return (
    <rect 
      x={innerRectX} 
      y={innerRectY} 
      width={innerRectWidth} 
      height={innerRectHeight} 
      fill="none" 
      stroke="#444444" 
      data-stroke-variable="--border"
      strokeWidth="1" 
    />
  );
};
